import type { ReactNode } from 'react';
import type {
  AlignmentValue,
  CollectionItem,
  ImageValue,
  LanguageValue,
  LinkValue,
  SizeValue,
  TextStyleValue,
  TimeFormatValue
} from '@elfsight/configurator-contracts';
import type {
  DayMonthFormat,
  RawSpecialInterval,
  Weekday,
  WorkingHours
} from '@elfsight/widget-business-hours/common';
import type { WidgetBackgroundProps } from '@elfsight/widget-ui';

export enum CTAButtonType {
  custom = 'custom',
  call = 'call',
  directions = 'directions',
  share = 'share',
  message = 'message',
  book = 'book',
  order = 'order',
  menu = 'menu',
  pricing = 'pricing',
  booking = 'booking',
  whatsapp = 'whatsapp',
  tripadvisor = 'tripadvisor',
  opentable = 'opentable',
  yelp = 'yelp',
  ubereats = 'ubereats'
}

export type LocationLabel = {
  id: string;
  text: string;
};

export type CTAButton = CollectionItem<{
  id: string;
  type: CTAButtonType;
  text: string;
  link?: string | LinkValue;
  icon?: ImageValue;
}>;

export type LocationPhotoPosition = 'left' | 'center' | 'right';
export type LocationPhotoMobilePosition = 'top' | 'bottom';
export type BusinessHoursDisplay = 'onPage' | 'onPopover' | 'none';

export interface LocationCardProps {
  businessName: ReactNode;
  businessAbout: ReactNode;
  businessAboutShortened: boolean;
  businessLogo: ImageValue;
  businessLogoStyle: 'default' | 'overlap';
  businessLogoSize: number;
  businessLogoColor?: string;

  contactsPhone: string;
  contactsWhatsApp: string;
  contactsInstagram: string;
  contactsEmail: string;
  contactsWebsite: string;
  contactsAddress: string;
  contactsLocationAddress?: string;
  contactsLocationName?: string;
  locationPhotoImage: ImageValue;
  locationPhotoPosition: LocationPhotoPosition;
  locationPhotoVerticalAspectRatio: number;
  locationPhotoHorizontalAspectRatio: number;
  locationPhotoDisplayMobile: boolean;
  locationPhotoMobilePosition: LocationPhotoMobilePosition;
  ctaButtons: CTAButton[];
  locationLabels: LocationLabel[];

  timeZone: string | undefined;
  language: LanguageValue | undefined;
  // TODO: удалить после перехода Store Locator на новый подход к локализации
  timeFormat?: TimeFormatValue;
  // TODO: удалить после перехода Store Locator на новый подход к локализации
  firstWeekday?: Weekday;

  contactsShowLabels: boolean;
  contactsShowIcons: boolean;
  businessHoursDisplay: BusinessHoursDisplay;

  specialIntervals: RawSpecialInterval[];
  daySundayHours: WorkingHours[];
  daySundayOpen: boolean;
  dayMondayHours: WorkingHours[];
  dayMondayOpen: boolean;
  dayTuesdayHours: WorkingHours[];
  dayTuesdayOpen: boolean;
  dayWednesdayHours: WorkingHours[];
  dayWednesdayOpen: boolean;
  dayThursdayHours: WorkingHours[];
  dayThursdayOpen: boolean;
  dayFridayHours: WorkingHours[];
  dayFridayOpen: boolean;
  daySaturdayHours: WorkingHours[];
  daySaturdayOpen: boolean;
  dayMonthFormat: DayMonthFormat;

  textColor: string;
  accentColor: string;
  platformCtaButtonColor: 'native' | 'accent';
  iconsColor: string;
  textStyle: TextStyleValue;
  alignment: AlignmentValue;
  businessNameStyle: TextStyleValue;
  openStatusColor: string;
  closedSoonStatusColor: string;
  closedStatusColor: string;
  ctaButtonsStyle: 'contain' | 'outline';
  ctaButtonsRadius: number;
  ctaButtonsSize: SizeValue;

  background: WidgetBackgroundProps;
  verticalPadding?: number;
  horizontalPadding?: number;
  renderThumbnailMode?: boolean;
  fullHeight?: boolean;

  footerOffset?: number;
  footerComponent?: ReactNode;

  editMode?: boolean;
}
